/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowBoardGameCafeVisitTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowBoardGameCafeVisit,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Play at the Café!",
    "Board Game Café Awaits!",
    "Games and Good Times!",
  ],
  title: "Board Game Café Visit",
  description: "Organize a fun visit to a board game café.",
  longDescription:
    "Gather your friends for a fun day at the board game café! Choose a date, decide on games to play, and plan snacks for the visit!",
  emoji: "🎲",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Party,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Board Game Café Visit",
          emoji: "🎲",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we visit the board game café?",
          emoji: "📅",
          completeAction: {
            question: "Decide on games to play?",
            description: "What games do we want to play at the café?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What games should we choose?",
                emoji: "🃏",
                completeAction: {
                  question: "Decide on snacks?",
                  description:
                    "What snacks should we enjoy during our café visit?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What snacks should we bring?",
                      emoji: "🍰",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let the Games Begin!",
    outroDescription:
      "Your board game café visit plans are set! Enjoy the fun!",
  },
};
